import { makeStyles } from '@material-ui/core/styles';

/**
 * Text colours come from `theme.palette.common.*`, which is generated from
 * `packages/fds-tokens/colors.ts` (`syncFdsColors`) — so they can't drift from
 * the design system the way a hand-copied hex table would.
 *
 * The three warm values below have no generated FDS source: the Compliance
 * upsell handoff uses the Compliance product's own accent and a peach gradient,
 * and `fds-tokens` has no entry within reach of them (the nearest, `orange400`
 * #ff721a, is a visibly different hue). They stay as named local constants,
 * following the same pattern as `containers/OfferLetterTemplates/fdsTokens.ts`.
 * Replace them with `theme.palette.common.*` if the design system ever adds
 * real Compliance-accent tokens.
 */
const COMPLIANCE_ACCENT = '#f86949';
const COMPLIANCE_SURFACE_FROM = '#fff2f0';
const COMPLIANCE_SURFACE_TO = '#ffded6';

export const useStyles = makeStyles(theme => ({
  card: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
    border: `1px solid ${COMPLIANCE_ACCENT}`,
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(1.625, 1.125, 1.625, 2.625),
    backgroundImage: `linear-gradient(85deg, ${COMPLIANCE_SURFACE_FROM} 0%, ${COMPLIANCE_SURFACE_TO} 100%)`,
  },
  icon: {
    flexShrink: 0,
    width: 24,
    height: 24,
  },
  content: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  headerRow: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    width: '100%',
    gap: theme.spacing(1),
  },
  title: {
    fontWeight: 500,
    fontSize: 18,
    lineHeight: '24px',
    color: theme.palette.common.gray800,
  },
  subtitle: {
    fontSize: 14,
    lineHeight: '20px',
    color: theme.palette.common.gray600,
  },
  dismissButton: {
    flexShrink: 0,
    padding: 0,
    width: theme.customHeights.smallButton,
    height: theme.customHeights.smallButton,
  },
  // Shrink to content rather than stretching across the card.
  discoverButtonWrapper: {
    alignSelf: 'flex-start',
  },
}));
